import { Modal } from "src/atoms/Modal";
import { StyledCloseButton } from "src/organisms/ProductView/ProductView.styled";
import {
  PhotoModalCloseWrapper,
  PhotoModalContainer,
} from "./ProductPhotos.styled";
import { ImageCarousel } from "./ImageCarousel";
import { useCallback, useEffect } from "react";

type ProductPhotoModalProps = {
  isZoomOpen: boolean;
  photos: string[];
  productName: string;
  setIsZoomOpen: (isOpen: boolean) => void;
  onClose?: () => void;
};

function ProductPhotoModal({
  isZoomOpen,
  photos,
  productName,
  setIsZoomOpen,
}: ProductPhotoModalProps): JSX.Element {
  const handleClose = useCallback(() => {
    setIsZoomOpen(false);
  }, [setIsZoomOpen]);

  useEffect(() => {
    // Prevent background scroll when modal is open
    // Mainly necessary for mobile devices
    if (isZoomOpen) {
      const scrollY = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
    } else {
      const scrollY = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";

      // Restore scroll position
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    }

    return () => {
      // Cleanup styles on unmount
      document.body.style.position = "";
      document.body.style.top = "";
    };
  }, [isZoomOpen]);

  return (
    <Modal
      isOpen={isZoomOpen}
      withHeader={false}
      onClose={handleClose}
      fullWidth
      fullHeight
      centerOnScreen
    >
      <PhotoModalContainer>
        <PhotoModalCloseWrapper>
          <StyledCloseButton
            sx={{ opacity: 0.5 }}
            fill="tone.anthraciteDark"
            onClick={() => {
              setIsZoomOpen(false);
            }}
          />
        </PhotoModalCloseWrapper>
        <ImageCarousel
          photos={photos}
          identifier="zoom"
          productName={productName}
        />
      </PhotoModalContainer>
    </Modal>
  );
}

export { ProductPhotoModal };
